/**
 * Formats a hash into a short version, e.g.: 0x + 4 first chars + 4 last chars
 *
 * @param {string} hash The hash to be shortened.
 * @param {number} [prefixCount] amount of characters before "..."
 * @param {number} [suffixCount] amount of characters after "..."
 * @returns {string} Returns the new format
 */
export const shortHash = (hash, prefixCount = 6, suffixCount = 4) =>
  hash ? `${hash.slice(0, prefixCount)}...${hash.slice(-suffixCount)}` : null
